import { render, staticRenderFns } from "./PaginaAdminAdministradores.vue?vue&type=template&id=0c52485a&lang=es"
import script from "./PaginaAdminAdministradores.vue?vue&type=script&lang=js"
export * from "./PaginaAdminAdministradores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports